import { render } from "./recording.vue?vue&type=template&id=b46dac2a&scoped=true"
import script from "./recording.vue?vue&type=script&lang=js"
export * from "./recording.vue?vue&type=script&lang=js"

import "./recording.vue?vue&type=style&index=0&id=b46dac2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b46dac2a"

export default script